import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Cms } from '@impact/data';
import { UtilsModule } from '../../utils/utils.module';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FeatureDetectionService } from '../../utils/helpers/feature-detection.service';
import SwiperCore,{ Navigation, Scrollbar } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { takeUntil } from 'rxjs/operators';
import { IImageBreakpoints } from '../../utils/responsive-image.component';
import { StyleBreakpoints } from '../../models/style-breakpoints';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { SectionHeaderModule } from '../../section-header/section-header.module';

SwiperCore.use([Navigation, Scrollbar]);
@Component({
    selector: 'app-carousel-content-spot',
    template: `
      <app-section-header [headerTextPrimary]="data?.carouselHeadingText"> </app-section-header>
        <div class="carousel-content-list">
            <swiper
                *ngIf="isBrowser"
                class="carousel-content-item__swiper"
                [slidesPerView]="slidesAmount"
                [slidesPerGroup]="slidesGroupAmount"
                [spaceBetween]="slidesSpace"
                [navigation]="true"
                [scrollbar]="{ draggable: true }"
                >
                <ng-template swiperSlide *ngFor="let item of data?.carouselContentItems">
                    <div [ngClass]="{
                        'has-background-color': item.backgroundColor,
                        'carousel-content-item': true
                        }">
                        <div class="carousel-item-content" [ngStyle]="{'background-color':item.backgroundColor}">
                            <div class="carousel-item-image-wrapper"  *ngIf="item.imageContent">
                                <app-responsive-image *ngIf="item.imageContent" [image]="item.imageContent" [breakpoints]="imageBreakpoints" [attr.aria-label]="item.imageContent.alt"></app-responsive-image>
                            </div>
                            <div class="carousel-item-rich-text">
                                <app-rich-text *ngIf="item.textContent" [html]="item.textContent"></app-rich-text>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </swiper>
        </div>
    `
})
class CarouselContentSpotComponent implements OnInit {
    static ref = 'carouselcontentspot';

    @Input() data: Cms.CarouselContentSpot;
    @Input() lazyLoad = true;

    isBrowser: boolean;
    slidesSpace: number;
    showNavigation: boolean;
    slidesAmount: number;
    slidesGroupAmount: number;

    imageBreakpoints: IImageBreakpoints[] = [{
        breakpoint: StyleBreakpoints.Xsmall,
        width: 410
    }, {
        breakpoint: StyleBreakpoints.Small,
        width: 718
    }, {
        breakpoint: StyleBreakpoints.Medium,
        width: 950
    }, {
        breakpoint: StyleBreakpoints.Large,
        width: 507
    }, {
        breakpoint: StyleBreakpoints.Xlarge,
        width: 630
    }];

    private readonly unsubscribe = new Subject<void>();

    constructor(
        private breakpointObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        featureDetectionService: FeatureDetectionService
    ) {
        this.isBrowser = featureDetectionService.isBrowser();
    }

    ngOnInit() {
        this.initSlider();
    }

    initSlider() {
        // Detect layout changes
        const queries$ = this.breakpointObserver.observe([
            '(min-width: 460px)',
            '(min-width: 768px)',
            '(min-width: 1024px)',
            '(min-width: 1200px)',
            '(min-width: 1580px)'
        ]);

        queries$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((result) => {

                if (!result.matches) {
                    this.setSlidesAmount(1);
                    this.slidesSpace = 14;
                } else {
                    if (result.breakpoints['(min-width: 1580px)'] === true) {
                        this.setSlidesAmount(3);
                        this.slidesSpace = 16;
                    } else if (result.breakpoints['(min-width: 1200px)'] === true) {
                        this.setSlidesAmount(3);
                        this.slidesSpace = 14;
                    } else if (result.breakpoints['(min-width: 1024px)'] === true) {
                        this.setSlidesAmount(3);
                        this.slidesSpace = 14;
                    } else if (result.breakpoints['(min-width: 768px)'] === true) {
                        this.setSlidesAmount(3);
                        this.slidesSpace = 14;
                    } else if (result.breakpoints['(min-width: 460px)'] === true) {
                        this.setSlidesAmount(2);
                        this.slidesSpace = 14;
                    }
                }
                this.cdr.detectChanges();
            });
    }

    setSlidesAmount(amount: number) {

        if (this.data.carouselContentItems.length > amount) {
            this.slidesAmount = amount + .1;
        } else {
            this.slidesAmount = amount;
        }

        if (this.data.carouselContentItems.length + 1 > amount) {
            this.showNavigation = true;
        } else {
            this.showNavigation = false;
        }
        this.slidesGroupAmount = amount;
    }
}

@NgModule({
    declarations: [CarouselContentSpotComponent],
    imports: [
        CommonModule,
        UtilsModule,
        SwiperModule,
        RichTextModule,
        SectionHeaderModule
    ]
})

class CarouselContentSpotComponentModule {}

export const LazySpotComponent = CarouselContentSpotComponent;
